export default __webpack_public_path__ + "static/media/chokingpowder.1103e65c.png";